import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.reception');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import * as QRCode from 'qrcode';

@Component({
    selector: 'wiz-page-reception',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.reception/view.scss */
:host {
  display: block;
  height: 100%;
}

.reception-shell {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  background: #f3f6f9;
}

.reception-header {
  gap: 12px;
  padding: 10px 14px;
  border-bottom-color: #cfd8e3;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.reception-header-main {
  min-width: 0;
  flex: 1;
}

.reception-header-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.reception-header-title-row {
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.reception-header-title {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
}

.reception-header-meta {
  font-size: 11px;
  color: #64748b;
}

.reception-header-meta--amber {
  color: #b45309;
  font-weight: 700;
}

.reception-header-sub {
  margin-top: 2px;
  font-size: 11px;
  color: #64748b;
}

.reception-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.reception-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 12px 14px 16px;
}

.reception-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 12px;
  min-height: 100%;
}

.reception-main-panel,
.reception-side-panel {
  min-width: 0;
}

.reception-side-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.reception-census-strip,
.reception-list-panel,
.reception-preintake-banner,
.reception-side-card {
  border: 1px solid #d8e1eb;
  background: #ffffff;
}

.reception-preintake-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 10px;
  padding: 12px 14px;
  border-left: 4px solid #f59e0b;
  background: linear-gradient(180deg, #fff9ed 0%, #ffffff 100%);
}

.reception-preintake-banner-main {
  min-width: 0;
  flex: 1;
}

.reception-preintake-banner-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #b45309;
}

.reception-preintake-banner-title {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.reception-preintake-banner-sub {
  margin-top: 4px;
  font-size: 11px;
  line-height: 1.5;
  color: #64748b;
}

.reception-preintake-banner-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.reception-preintake-chip-row {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.reception-preintake-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #fcd34d;
  background: #ffffff;
  padding: 6px 10px;
  font-size: 11px;
  color: #334155;
  transition: border-color 0.15s, background-color 0.15s;
  cursor: pointer;
}
.reception-preintake-chip:hover {
  border-color: #f59e0b;
  background: #fffdf7;
}

.reception-preintake-chip-name {
  font-weight: 700;
  color: #0f172a;
}

.reception-preintake-chip-meta {
  color: #64748b;
}

.reception-census-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  margin-bottom: 10px;
}

.reception-census-cell {
  padding: 10px 12px;
  border-right: 1px solid #e2e8f0;
  border-top: 3px solid #cbd5e1;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s;
  cursor: pointer;
}
.reception-census-cell:last-child {
  border-right: 0;
}
.reception-census-cell:hover {
  background: #f8fafc;
}

.reception-census-cell--amber {
  border-top-color: #f59e0b;
}

.reception-census-cell--orange {
  border-top-color: #f97316;
}

.reception-census-cell--emerald {
  border-top-color: #10b981;
}

.reception-census-cell--blue {
  border-top-color: #3b82f6;
}

.reception-census-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.reception-census-value {
  display: block;
  margin-top: 4px;
  font-size: 22px;
  line-height: 1;
  font-weight: 800;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.reception-census-sub {
  display: block;
  margin-top: 4px;
  font-size: 10px;
  color: #94a3b8;
}

.reception-list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.reception-panel-kicker,
.reception-side-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.reception-panel-title {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.reception-panel-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 10px;
  color: #64748b;
}

.reception-filter-strip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  overflow: auto;
}

.reception-filter-btn {
  padding: 4px 8px;
  border: 1px solid #d7e0ea;
  background: #f8fafc;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  white-space: nowrap;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
}
.reception-filter-btn:hover {
  background: #ffffff;
  border-color: #94a3b8;
}

.reception-filter-btn--active {
  background: #0f172a;
  border-color: #0f172a;
  color: #ffffff;
}

.reception-filter-btn--amber.reception-filter-btn--active {
  background: #92400e;
  border-color: #92400e;
}

.reception-filter-btn--orange.reception-filter-btn--active {
  background: #c2410c;
  border-color: #c2410c;
}

.reception-filter-btn--emerald.reception-filter-btn--active {
  background: #047857;
  border-color: #047857;
}

.reception-filter-btn--blue.reception-filter-btn--active {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.reception-table-wrap {
  overflow: auto;
}

.reception-table th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.reception-table-row {
  cursor: pointer;
}
.reception-table-row:hover {
  background: #f8fafc;
}

.reception-table-row--urgent {
  background: #fff9ed;
}

.reception-row-index {
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
}

.reception-patient-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.reception-avatar {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.reception-patient-name {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}

.reception-patient-meta,
.reception-type-text,
.reception-doctor-text,
.reception-reason-text,
.reception-wait-text {
  font-size: 11px;
}

.reception-patient-meta {
  color: #64748b;
}

.reception-type-text,
.reception-doctor-text {
  color: #334155;
}

.reception-reason-text {
  max-width: 220px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reception-wait-text {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.reception-empty-state {
  padding: 48px 24px;
  text-align: center;
}

.reception-empty-title {
  font-size: 14px;
  font-weight: 700;
  color: #475569;
}

.reception-empty-sub {
  margin-top: 6px;
  font-size: 11px;
  color: #94a3b8;
}

.reception-empty-actions {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.reception-side-card {
  padding: 10px 12px;
}

.reception-priority-name {
  margin-top: 8px;
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
}

.reception-priority-meta {
  margin-top: 3px;
  font-size: 11px;
  color: #64748b;
}

.reception-priority-note {
  margin-top: 8px;
  min-height: 42px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 8px;
  font-size: 11px;
  line-height: 1.45;
  color: #475569;
}

.reception-priority-actions,
.reception-preintake-actions {
  margin-top: 8px;
  display: flex;
  gap: 8px;
}

.reception-preintake-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #eef2f7;
  text-align: left;
  cursor: pointer;
}
.reception-preintake-row:hover {
  color: #0f172a;
}

.reception-preintake-row-main {
  min-width: 0;
  flex: 1;
}

.reception-preintake-row-name {
  font-size: 11px;
  font-weight: 700;
  color: #0f172a;
}

.reception-preintake-row-meta {
  margin-top: 2px;
  font-size: 10px;
  color: #64748b;
}

.reception-preintake-row-action {
  font-size: 10px;
  font-weight: 700;
  color: #b45309;
  white-space: nowrap;
}

.reception-priority-empty {
  margin-top: 8px;
  border: 1px dashed #d7e0ea;
  background: #f8fafc;
  padding: 12px;
  font-size: 11px;
  color: #64748b;
}

.reception-preintake-count {
  margin-top: 8px;
  font-size: 22px;
  line-height: 1;
  font-weight: 800;
  color: #0f172a;
}

.reception-preintake-note {
  margin-top: 4px;
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
}

.reception-snapshot-row,
.reception-mini-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #eef2f7;
  text-align: left;
  transition: color 0.15s;
  cursor: pointer;
}
.reception-snapshot-row:last-child,
.reception-mini-row:last-child {
  border-bottom: 0;
}
.reception-snapshot-row:hover,
.reception-mini-row:hover {
  color: #0f172a;
}

.reception-snapshot-row span,
.reception-snapshot-row strong {
  font-size: 11px;
}

.reception-snapshot-row span {
  color: #475569;
}

.reception-snapshot-row strong {
  font-weight: 800;
  color: #0f172a;
}

.reception-mini-main {
  min-width: 0;
  flex: 1;
}

.reception-mini-name {
  font-size: 11px;
  font-weight: 700;
  color: #0f172a;
}

.reception-mini-meta {
  margin-top: 2px;
  font-size: 10px;
  color: #64748b;
}

.reception-mini-action {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  white-space: nowrap;
}

@media (max-width: 1279px) {
  .reception-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .reception-census-strip {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 767px) {
  .reception-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .reception-preintake-banner {
    align-items: flex-start;
    flex-direction: column;
  }
  .reception-header-actions {
    width: 100%;
  }
  .reception-census-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .reception-filter-strip {
    flex-wrap: wrap;
  }
}
@keyframes pulse-gentle {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}`],
})
export class PageReceptionComponent implements OnInit, OnDestroy {
    public visits: any[] = [];
    public stats: any = {
        total: 0, waiting: 0, intake: 0, ready: 0,
        in_progress: 0, charting: 0, prescribing: 0,
        completed: 0, cancelled: 0,
    };
    public doctors: any[] = [];
    public statusFilter: string = 'all';
    public preIntakePending: number = 0;
    public recentPreIntakes: any[] = [];

    // 접수 모달
    public showModal: boolean = false;
    public searchText: string = '';
    public searchResults: any[] = [];
    public selectedPatient: any = null;
    public visitForm: any = { doctor_id: '', visit_type: 'outpatient', memo: '' };

    // 사전예진 모달
    public showPreIntakeModal: boolean = false;
    public preIntakeQuery: string = '';
    public preIntakeResults: any[] = [];
    public selectedPreIntake: any = null;
    public preIntakeMatches: any[] = [];
    public preIntakePatientQuery: string = '';
    public preIntakePatientResults: any[] = [];
    public selectedPreIntakePatient: any = null;
    public showPreIntakeNewPatient: boolean = false;
    public preIntakeNewPatientForm: any = { name: '', phone: '', gender: '', birth_date: '' };
    public preIntakeVisitForm: any = { doctor_id: '', visit_type: 'outpatient', memo: '' };

    // QR 모달
    public showQrModal: boolean = false;
    public publicIntakeUrl: string = '';
    public publicIntakeQr: string = '';
    public publicIntakeUrlConfig: string = '';

    // 간편 환자 등록
    public showNewPatient: boolean = false;
    public newPatientForm: any = { name: '', phone: '', gender: '', birth_date: '' };

    private refreshInterval: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
        this.refreshInterval = setInterval(() => this.load(), 5000);
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.refreshInterval) clearInterval(this.refreshInterval);
    }

    public async load() {
        const { code, data } = await wiz.call('load');
        if (code === 200) {
            this.visits = data.visits || [];
            this.stats = data.stats || {};
            this.doctors = data.doctors || [];
            this.preIntakePending = data.pre_intake_pending || 0;
            this.recentPreIntakes = data.recent_pre_intakes || [];
            this.publicIntakeUrlConfig = data.public_intake_url || '';
        }
        await this.service.render();
    }

    // ── 필터 / 정렬 ──

    public setFilter(filter: string) {
        this.statusFilter = filter;
        this.service.render();
    }

    public filteredVisits() {
        if (this.statusFilter === 'all') return this.visits;
        if (this.statusFilter === 'follow_up') {
            return this.visits.filter((v: any) => ['in_progress', 'charting', 'prescribing'].includes(v.status));
        }
        return this.visits.filter((v: any) => v.status === this.statusFilter);
    }

    private waitMinutes(visit: any): number {
        if (!visit?.created_at) return 0;
        const created = new Date(visit.created_at);
        if (Number.isNaN(created.getTime())) return 0;
        return Math.max(0, Math.floor((Date.now() - created.getTime()) / 60000));
    }

    public filteredVisitsSorted() {
        const order: any = {
            waiting: 0, intake: 1, ready: 2, in_progress: 3,
            charting: 4, prescribing: 5, completed: 6, cancelled: 7,
        };
        return [...this.filteredVisits()].sort((a: any, b: any) => {
            const d = (order[a.status] ?? 9) - (order[b.status] ?? 9);
            return d !== 0 ? d : this.waitMinutes(b) - this.waitMinutes(a);
        });
    }

    public getFollowUpCount() {
        return Number(this.stats.in_progress || 0) + Number(this.stats.charting || 0) + Number(this.stats.prescribing || 0);
    }

    // ── 표시 헬퍼 ──

    public getInitial(visit: any): string {
        return (visit.patient_name || '?').charAt(0);
    }

    public getAvatarClass(visit: any): string {
        if (['waiting', 'intake'].includes(visit.status) && this.waitMinutes(visit) >= 20)
            return 'bg-amber-100 text-amber-700';
        if (visit.status === 'ready') return 'bg-emerald-100 text-emerald-700';
        if (['in_progress', 'charting', 'prescribing'].includes(visit.status)) return 'bg-blue-100 text-blue-700';
        return 'bg-slate-100 text-slate-500';
    }

    public getRowClass(visit: any): string {
        if (['waiting', 'intake'].includes(visit.status) && this.waitMinutes(visit) >= 20)
            return 'bg-amber-50/60 hover:bg-amber-50';
        return 'hover:bg-slate-50';
    }

    public getActionBtnClass(visit: any): string {
        if (['waiting', 'intake', 'ready'].includes(visit.status)) return 'emr-btn-primary';
        return 'emr-btn-default';
    }

    public canCancel(visit: any): boolean {
        return ['waiting', 'intake', 'ready'].includes(visit.status);
    }

    public getEmptyMessage(): string {
        if (this.statusFilter === 'all') return '오늘 등록된 접수가 없습니다';
        const labels: any = {
            waiting: '접수대기', intake: '예진', ready: '진료대기',
            follow_up: '진행중', completed: '완료',
        };
        return `${labels[this.statusFilter] || ''} 상태의 접수가 없습니다`;
    }

    public getAge(birthDate: string) {
        if (!birthDate) return '-';
        const birth = new Date(birthDate);
        if (Number.isNaN(birth.getTime())) return '-';
        return `${Math.floor((Date.now() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000))}세`;
    }

    public getWaitTime(visit: any): string {
        if (['completed', 'cancelled'].includes(visit.status)) return '-';
        const m = this.waitMinutes(visit);
        if (m < 1) return '방금';
        if (m < 60) return `${m}분`;
        return `${Math.floor(m / 60)}h ${m % 60}m`;
    }

    public getWaitColor(visit: any): string {
        if (['completed', 'cancelled'].includes(visit.status)) return 'text-slate-300';
        const m = this.waitMinutes(visit);
        if (m > 30) return 'text-red-600 font-bold';
        if (m > 15) return 'text-amber-600';
        return 'text-slate-500';
    }

    public isUrgentVisit(visit: any): boolean {
        return ['waiting', 'intake'].includes(visit.status) && this.waitMinutes(visit) >= 20;
    }

    public getStatusLabel(status: string) {
        const map: any = {
            waiting: '접수대기', intake: '예진중', ready: '진료대기',
            in_progress: '진료중', charting: '기록정리',
            prescribing: '처방·후속', completed: '완료', cancelled: '취소'
        };
        return map[status] || status;
    }

    public getStatusBadge(status: string) {
        const map: any = {
            waiting: 'bg-amber-50 text-amber-700',
            intake: 'bg-orange-50 text-orange-700',
            ready: 'bg-emerald-50 text-emerald-700',
            in_progress: 'bg-blue-50 text-blue-700',
            charting: 'bg-indigo-50 text-indigo-700',
            prescribing: 'bg-violet-50 text-violet-700',
            completed: 'bg-slate-50 text-slate-500',
        };
        return map[status] || 'bg-slate-50 text-slate-500';
    }

    public getStatusDot(status: string) {
        const map: any = {
            waiting: 'bg-amber-400', intake: 'bg-orange-400',
            ready: 'bg-emerald-400', in_progress: 'bg-blue-400',
            charting: 'bg-indigo-400', prescribing: 'bg-violet-400',
            completed: 'bg-slate-300',
        };
        return map[status] || 'bg-slate-300';
    }

    public getVisitTypeLabel(type: string) {
        const map: any = { outpatient: '초진', revisit: '재진', emergency: '응급' };
        return map[type] || type;
    }

    public getVisitTypeBadgeClass(type: string) {
        const map: any = {
            outpatient: '', revisit: 'text-violet-600', emergency: 'text-rose-600 font-semibold',
        };
        return map[type] || '';
    }

    public getVisitActionLabel(visit: any) {
        if (visit.status === 'waiting') return '예진 시작';
        if (visit.status === 'intake') return '예진 완료';
        if (visit.status === 'ready') return '진료 차트';
        if (visit.status === 'prescribing') return '후속 확인';
        if (visit.status === 'completed') return '기록 보기';
        return '진행 확인';
    }

    public activeFilterLabel() {
        const map: any = {
            all: '전체 접수 흐름',
            waiting: '접수 대기',
            intake: '예진 진행',
            ready: '진료 대기',
            follow_up: '진행 · 후속',
            completed: '완료 접수',
        };
        return map[this.statusFilter] || '전체 접수 흐름';
    }

    public nextPriorityVisit() {
        return this.filteredVisitsSorted()[0] || null;
    }

    public prioritySupportText(visit: any) {
        return visit?.visit_reason || visit?.memo || '추가 메모가 없습니다.';
    }

    public recentVisits(limit: number = 5) {
        return this.filteredVisitsSorted().slice(0, limit);
    }

    public latestPreIntake() {
        return this.recentPreIntakes[0] || null;
    }

    public getPreIntakePersonLabel(item: any) {
        if (!item) return '-';
        return item.phone || item.birth_date || '연락 정보 없음';
    }

    public getPreIntakeTimeLabel(item: any) {
        if (!item) return '-';
        const raw = item.completed_at || item.created || '';
        if (!raw) return '-';
        const date = new Date(raw);
        if (Number.isNaN(date.getTime())) return String(raw).slice(11, 16) || String(raw);
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
    }

    public async openPreIntakeModal(item?: any) {
        this.showPreIntakeModal = true;
        this.preIntakeQuery = '';
        this.preIntakeResults = [];
        this.selectedPreIntake = null;
        this.preIntakeMatches = [];
        this.selectedPreIntakePatient = null;
        this.showPreIntakeNewPatient = false;
        this.preIntakeNewPatientForm = { name: '', phone: '', gender: '', birth_date: '' };
        this.preIntakeVisitForm = { doctor_id: '', visit_type: 'outpatient', memo: '' };
        await this.searchPreIntakes();
        if (item?.id) {
            await this.selectPreIntake(item);
            return;
        }
        await this.service.render();
    }

    // ── 액션 ──

    public async handleAction(visit: any) {
        if (visit.status === 'waiting') {
            await this.changeStatus(visit, 'intake');
        } else if (visit.status === 'intake') {
            await this.changeStatus(visit, 'ready');
        } else {
            this.service.href(`/chart/${visit.id}`);
        }
    }

    public async changeStatus(visit: any, status: string) {
        const { code } = await wiz.call('update_status', { id: visit.id, status });
        if (code === 200) await this.load();
    }

    public async cancelVisit(visit: any) {
        const res = await this.service.modal.show({
            title: '접수 취소',
            message: `${visit.patient_name} 환자의 접수를 취소하시겠습니까?`,
            action: '취소', actionBtn: 'bg-red-500', cancel: '닫기'
        });
        if (res) {
            const { code } = await wiz.call('cancel_visit', { id: visit.id });
            if (code === 200) await this.load();
        }
    }

    // ── 새 접수 모달 ──

    public openReceptionModal() {
        this.showModal = true;
        this.searchText = '';
        this.searchResults = [];
        this.selectedPatient = null;
        this.showNewPatient = false;
        this.newPatientForm = { name: '', phone: '', gender: '', birth_date: '' };
        this.visitForm = { doctor_id: '', visit_type: 'outpatient', memo: '' };
        this.service.render();
    }

    public closeModal() {
        this.showModal = false;
        this.service.render();
    }

    public async searchPatient() {
        if (this.searchText.length < 1) {
            this.searchResults = [];
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call('search_patient', { text: this.searchText });
        if (code === 200) this.searchResults = data;
        await this.service.render();
    }

    public selectPatient(patient: any) {
        this.selectedPatient = patient;
        this.searchResults = [];
        this.searchText = patient.name;
        this.service.render();
    }

    public clearSelectedPatient() {
        this.selectedPatient = null;
        this.searchText = '';
        this.service.render();
    }

    public toggleNewPatient() {
        this.showNewPatient = !this.showNewPatient;
        this.selectedPatient = null;
        this.service.render();
    }

    public async registerNewPatient() {
        if (!this.newPatientForm.name) {
            await this.service.modal.show({ title: '알림', message: '환자명을 입력해주세요', action: '확인' });
            return false;
        }
        if (!this.newPatientForm.phone && !this.newPatientForm.birth_date) {
            await this.service.modal.show({ title: '알림', message: '연락처 또는 생년월일 중 하나를 입력해주세요', action: '확인' });
            return false;
        }
        const { code, data } = await wiz.call('create_patient_quick', this.newPatientForm);
        if (code === 200) {
            this.selectedPatient = data;
            this.showNewPatient = false;
            this.searchText = data.name;
            await this.service.render();
            return true;
        }
        await this.service.modal.show({ title: '오류', message: data.message || '환자 등록 실패', action: '확인' });
        return false;
    }

    public async submitReception() {
        if (this.showNewPatient && !this.selectedPatient) {
            const ok = await this.registerNewPatient();
            if (!ok) return;
        }
        if (!this.selectedPatient) {
            await this.service.modal.show({ title: '알림', message: '환자를 선택해주세요', action: '확인' });
            return;
        }
        if (!this.visitForm.doctor_id) {
            await this.service.modal.show({ title: '알림', message: '담당의를 선택해주세요', action: '확인' });
            return;
        }
        const { code, data } = await wiz.call('create_visit', {
            patient_id: this.selectedPatient.id,
            doctor_id: this.visitForm.doctor_id,
            visit_type: this.visitForm.visit_type,
            memo: this.visitForm.memo
        });
        if (code === 200) {
            this.closeModal();
            await this.load();
        } else {
            await this.service.modal.show({ title: '오류', message: data.message || '접수 실패', action: '확인' });
        }
    }

    // ── 사전예진 모달 ──

    public closePreIntakeModal() {
        this.showPreIntakeModal = false;
        this.service.render();
    }

    public async searchPreIntakes() {
        const { code, data } = await wiz.call('search_pre_intakes', { query: this.preIntakeQuery });
        if (code === 200) this.preIntakeResults = data.rows || [];
        await this.service.render();
    }

    public async selectPreIntake(item: any) {
        const { code, data } = await wiz.call('get_pre_intake', { id: item.id });
        if (code !== 200) return;
        this.selectedPreIntake = data.intake || null;
        this.preIntakeMatches = data.matches || [];
        this.selectedPreIntakePatient = this.preIntakeMatches.length === 1 ? this.preIntakeMatches[0] : null;
        this.showPreIntakeNewPatient = this.preIntakeMatches.length === 0;
        this.preIntakeNewPatientForm = {
            name: this.selectedPreIntake?.name || '',
            phone: this.selectedPreIntake?.phone || '',
            gender: this.selectedPreIntake?.gender || '',
            birth_date: this.selectedPreIntake?.birth_date || '',
        };
        this.preIntakeVisitForm = {
            doctor_id: '',
            visit_type: this.selectedPreIntake?.visit_type || 'outpatient',
            memo: '',
        };
        await this.service.render();
    }

    public choosePreIntakePatient(patient: any) {
        this.selectedPreIntakePatient = patient;
        this.showPreIntakeNewPatient = false;
        this.service.render();
    }

    public togglePreIntakeNewPatient() {
        this.showPreIntakeNewPatient = !this.showPreIntakeNewPatient;
        if (this.showPreIntakeNewPatient) this.selectedPreIntakePatient = null;
        this.service.render();
    }

    public async applyPreIntakeToVisit() {
        if (!this.selectedPreIntake) {
            await this.service.modal.show({ title: '알림', message: '사전 예진을 선택해주세요', action: '확인' });
            return;
        }
        if (!this.preIntakeVisitForm.doctor_id) {
            await this.service.modal.show({ title: '알림', message: '담당의를 선택해주세요', action: '확인' });
            return;
        }
        if (!this.showPreIntakeNewPatient && !this.selectedPreIntakePatient) {
            await this.service.modal.show({ title: '알림', message: '환자를 선택하거나 신규 등록을 선택해주세요', action: '확인' });
            return;
        }

        let patientId = this.selectedPreIntakePatient?.id || '';
        if (this.showPreIntakeNewPatient) {
            const { code, data } = await wiz.call('create_patient_quick', this.preIntakeNewPatientForm);
            if (code !== 200) {
                await this.service.modal.show({ title: '오류', message: data?.message || '환자 생성 실패', action: '확인' });
                return;
            }
            patientId = data.id || data.patient?.id || '';
        }

        const { code, data } = await wiz.call('create_visit_from_pre_intake', {
            pre_intake_id: this.selectedPreIntake.id,
            patient_id: patientId,
            doctor_id: this.preIntakeVisitForm.doctor_id,
            visit_type: this.preIntakeVisitForm.visit_type,
            memo: this.preIntakeVisitForm.memo,
        });
        if (code !== 200) {
            await this.service.modal.show({ title: '오류', message: data?.message || '접수 연결 실패', action: '확인' });
            return;
        }
        this.closePreIntakeModal();
        await this.load();
        await this.service.modal.show({ title: '완료', message: '사전 예진이 접수에 연결되었습니다.', action: '확인' });
    }

    // ── QR 모달 ──

    public async openQrModal() {
        await this.load();
        this.showQrModal = true;

        this.publicIntakeUrl = this.publicIntakeUrlConfig || '';
        if (!this.publicIntakeUrl) {
            this.showQrModal = false;
            await this.service.render();
            await this.service.modal.show({ title: '오류', message: '공개 예진 URL이 설정되지 않았습니다.', action: '확인' });
            return;
        }

        try {
            this.publicIntakeQr = await QRCode.toDataURL(this.publicIntakeUrl, {
                width: 220, margin: 1,
                color: { dark: '#0f172a', light: '#ffffff' },
            });
        } catch { this.publicIntakeQr = ''; }
        await this.service.render();
    }

    public closeQrModal() {
        this.showQrModal = false;
        this.service.render();
    }

    public async copyPublicIntakeUrl() {
        try {
            await navigator.clipboard.writeText(this.publicIntakeUrl);
            await this.service.modal.show({ title: '복사 완료', message: '예진 링크를 복사했습니다.', action: '확인' });
        } catch {
            await this.service.modal.show({ title: '복사 실패', message: '브라우저에서 복사를 허용하지 않았습니다.', action: '확인' });
        }
    }
}

export default PageReceptionComponent;